'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _someInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/some');
var _startsWithInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/starts-with');
var loadingJob_model = require('./loading-job.model.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _someInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_someInstanceProperty);
var _startsWithInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_startsWithInstanceProperty);

var GSQLDataSourceLogic = /*#__PURE__*/function () {
  function GSQLDataSourceLogic() {
    _classCallCheck__default["default"](this, GSQLDataSourceLogic);
  }
  return _createClass__default["default"](GSQLDataSourceLogic, null, [{
    key: "isKafkaLoadingJob",
    value:
    /**
     * Check if loading job is a Kafka loading job.
     *
     * @param {string} jobName
     * @returns {boolean}
     */
    function isKafkaLoadingJob(jobName) {
      var _context;
      // TODO: Support more data source types in the future.
      return _someInstanceProperty__default["default"](_context = [loadingJob_model.LoadingJobPrefix.GCS, loadingJob_model.LoadingJobPrefix.S3, loadingJob_model.LoadingJobPrefix.ABS]).call(_context, function (prefix) {
        return _startsWithInstanceProperty__default["default"](jobName).call(jobName, prefix);
      });
    }
  }]);
}();

exports.GSQLDataSourceLogic = GSQLDataSourceLogic;
